import { combineReducers } from 'redux'
import app from './app'
import action from './action'
import actions from './actions'
import location from './location'
import locations from './locations'
import stakeholder from './stakeholder'
import notifications from './notifications'

export default combineReducers({
  app,
  action,
  actions,
  location,
  locations,
  stakeholder,
  notifications,
})
